import React from 'react'
import { AiFillShopping, AiOutlineBarChart, AiOutlineSearch } from "react-icons/ai";
import { SiZapier, SiAntdesign } from "react-icons/si";
import { FaMobileAlt, FaGlobe, FaDatabase, FaRetweet, FaChartLine } from "react-icons/fa";

import Title from '../layouts/Title';
import Card from './Card';

const Features = () => {
  return (
    <section
      id="features"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <Title title="Features" des="What I Do" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
        <Card
          title="E-Commerce Development"
          des="I build high-performing online stores using Shopify, Shopify Plus, and WooCommerce—covering migrations, redesigns, and custom feature development."
          icon={<AiFillShopping />}
        />
        <Card
          title="SEO Optimization"
          des="I implement comprehensive SEO strategies including technical SEO, metadata optimization, schema markup, site architecture, and content optimization to improve search rankings and organic traffic."
          icon={<AiOutlineSearch />}
        />
        <Card
          title="Google Analytics & Data Analytics"
          des="I set up and optimize Google Analytics (GA4), configure conversion tracking, create custom dashboards, analyze user behavior, and provide actionable insights to drive data-driven business decisions."
          icon={<FaChartLine />}
        />
        <Card
          title="Conversion Rate Optimization (CRO)"
          des="I implement data-driven A/B testing, funnel optimization, and user experience improvements to increase engagement and sales conversions based on analytics insights."
          icon={<AiOutlineBarChart />}
        />
        <Card
          title="Custom Integrations & Automation"
          des="I integrate APIs, third-party apps, and automation tools (Zapier, Make.com, Pabbly) to streamline workflows and reduce operational overhead."
          icon={<SiZapier />}
        />
        <Card
          title="UX/UI Design & Branding"
          des="I craft user-friendly shopping experiences with optimized navigation, modern design systems, and brand storytelling that connect with customers."
          icon={<FaMobileAlt />}
        />
        <Card
          title="Headless & Advanced Architectures"
          des="I develop scalable headless storefronts (Shopify + Next.js, Hydrogen) for lightning-fast performance and future-ready e-commerce."
          icon={<SiAntdesign />}
        />
        <Card
          title="Payment & Logistics Solutions"
          des="I configure secure payment systems (Stripe, PayPal, AfterPay, Paidy, Konbini) and shipping integrations (ShipStation, EasyPost) tailored to global markets."
          icon={<FaGlobe />}
        />
        <Card
          title="Data Migration & Customization"
          des="I handle complex platform migrations, variant limitations, and bespoke product builders while ensuring CRM and marketing integrations remain intact."
          icon={<FaDatabase />}
        />
        <Card
          title="Marketing & Retention Strategy"
          des="I set up loyalty programs, Klaviyo automations, and full-funnel marketing campaigns to boost retention and customer lifetime value."
          icon={<FaRetweet />}
        />
      </div>
    </section>
  );
}

export default Features